module.exports = __webpack_public_path__ + "img/20240531_5.8e70272c.jpg";